export const getBaseUrl = () => {
  let organization_code = localStorage.getItem("organization_code");
  let checkPractice = organization_code ? organization_code : '';
  let organization_config = localStorage.getItem("organization_config");
  let organization_config_obj = organization_config ? JSON.parse(organization_config) : [];
  let checkPracticeObj = organization_config_obj?.find((item) =>
    item?.short_code?.toLowerCase()?.includes(checkPractice?.toLowerCase())
  );
  if (checkPracticeObj?.api_url) {
    let url = checkPracticeObj.api_url.split(/(https:\/\/api-)/);
    return url[1] + "e10x-" + url[2];
  } else {
    return process.env.REACT_APP_API_URL_V1;
  }
};

export const getPlainApiUrl = () => {
  // returns the ehr api url without the e10x prefix
  let organization_code = localStorage.getItem("organization_code");
  let checkPractice = organization_code ? organization_code : '';
  let organization_config = localStorage.getItem("organization_config");
  let organization_config_obj = organization_config ? JSON.parse(organization_config) : [];
  let checkPracticeObj = organization_config_obj?.find((item) =>
    item?.short_code?.toLowerCase()?.includes(checkPractice?.toLowerCase())
  );
  if (checkPracticeObj?.api_url) {
    return checkPracticeObj?.api_url;
  } else {
    return 'https://api.ethizo.com';
  }
};

export const getPusherConf = () => {
  let organization_code = localStorage.getItem("organization_code");
  let checkPractice = organization_code ? organization_code : '';
  let organization_config = localStorage.getItem("organization_config");
  let organization_config_obj = organization_config ? JSON.parse(organization_config) : [];
  let checkPracticeObj = organization_config_obj?.find((item) =>
    item?.short_code?.toLowerCase()?.includes(checkPractice?.toLowerCase())
  );
  if (checkPracticeObj?.pusher_settings && checkPracticeObj?.pusher_settings?.key) {
    return {
      key: checkPracticeObj?.pusher_settings?.key,
      cluster: checkPracticeObj?.pusher_settings?.cluster,
    };
  } else {
    return {
      key: process.env.REACT_APP_PUSHER_ENV_KEY,
      cluster: process.env.REACT_APP_PUSHER_ENV_CLUSTER,
    };
  }
};

export function createSSE(url, closeHandler) {
  let onMessageCallback = null;
  let onErrorCallback = null;

  const eventSource = new EventSource(getBaseUrlForEsync() + url);

  eventSource.onmessage = (event) => {
    if (onMessageCallback) {
      if (JSON.parse(event.data)){
        onMessageCallback(JSON.parse(event.data));
      }
    }
    eventSource.addEventListener('close', function(event) {
      closeHandler(event)
      eventSource.close();
    });
  };

  eventSource.onerror = (error) => {
    if (onErrorCallback) {
      onErrorCallback(error);
    }
    eventSource.close();
  };

  return {
    then(callback) {
      onMessageCallback = callback;
      return this;
    },
    catch(callback) {
      onErrorCallback = callback;
      return this;
    },
    close() {
      eventSource.close();
    },
  };
}


export const  getBaseUrlForEsync=()=>{
  let pythonUrl=JSON.parse(localStorage.getItem("esyncConfig"))?.pycore_server 
  if (pythonUrl){
    return pythonUrl
  }else{
    return process.env.REACT_APP_API_URL_V2 || "https://pycore-blue.ethizo.com"
  }
}